import { useCallback, useEffect, useState } from 'react';
import { bffQuery } from '@parsina/framework/clinical/src/lib/bffClient';

// The signed-in practitioner's presence hours across every clinic — what the
// «کجا هستم» line and the AUTO clinic lens read (see Reception.shared
// `resolvePlace`). Clinic staff write these rows; the doctor app only reads.
//
// Fetched once per mount and again whenever the tab comes back into view: a
// shift edited at the desk shows up when the doctor returns to the app.
//
// **An error is not an empty schedule.** `status: 'error'` makes the place line
// say nothing about where the doctor is; `[]` with 'ready' is the real claim
// «no hours registered». A BFF too old to know the field fails validation and
// lands on 'error' too — the screen works, it just makes no place claim.

const PRESENCE_QUERY = `
  query MyPresenceSchedule {
    myPresenceSchedule { id clinicId dayOfWeek specificDate startMinute endMinute }
  }
`;

export function usePresenceSchedule() {
  const [state, setState] = useState({ windows: [], status: 'loading' });

  const load = useCallback(() => {
    let alive = true;
    bffQuery(PRESENCE_QUERY)
      .then((data) => {
        if (!alive) return;
        const rows = data?.myPresenceSchedule;
        setState(Array.isArray(rows)
          ? { windows: rows, status: 'ready' }
          : { windows: [], status: 'error' });
      })
      .catch((err) => {
        if (!alive) return;
        console.error('myPresenceSchedule error:', err);
        setState((s) => (s.status === 'ready' ? s : { windows: [], status: 'error' }));
      });
    return () => { alive = false; };
  }, []);

  useEffect(() => {
    let cancel = load();
    const onVisible = () => {
      if (document.visibilityState !== 'visible') return;
      cancel?.();
      cancel = load();
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      cancel?.();
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [load]);

  return state;
}
